/* ALECOO Gratis-Twilly. Einstellungen, Texte und Zuordnung: sections/alecoo-match.liquid
   Regel: ein Gratis-Tuch je Halsband der Aktion. */
(function () {
  var cfg = document.getElementById('AlMatchConfig');
  if (!cfg || !window.fetch || !window.Promise) return;
  var d = cfg.dataset;
  var CODE = d.code;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var scarves = d.scarves.split(',');
  var pairs = {};
  d.pairs.split(',').forEach(function (pair) {
    var parts = pair.split('>');
    if (parts.length === 2) pairs[parts[0]] = parts[1];
  });
  var nativeFetch = window.fetch.bind(window);
  var running = false;
  var again = false;
  var lists = {};

  function wait(ms) { return new Promise(function (resolve) { window.setTimeout(resolve, ms); }); }

  // Anfrage an den Shop. Kommt keine lesbare Antwort, einmal neu versuchen (nicht beim Hinzufügen,
  // damit nichts doppelt im Warenkorb landet). Fehlertexte kommen vom Shop oder aus den Texten der Seite.
  function call(path, body, retried) {
    var options = { headers: { Accept: 'application/json' } };
    if (body) {
      options.method = 'POST';
      options.headers['Content-Type'] = 'application/json';
      options.body = JSON.stringify(body);
    }
    var mayRetry = !retried && (!body || path.indexOf('update') > -1);
    return nativeFetch(root + path, options).then(function (response) {
      return response.text().then(function (text) {
        var data = null;
        try { data = JSON.parse(text); } catch (err) { data = null; }
        if (data && response.ok) return data;
        if (!data && mayRetry) return wait(1200).then(function () { return call(path, body, true); });
        throw new Error((data && (data.description || data.message)) || '');
      });
    }, function () {
      if (mayRetry) return wait(1200).then(function () { return call(path, body, true); });
      throw new Error('');
    });
  }

  function products(handle) {
    if (!lists[handle]) {
      lists[handle] = call('collections/' + handle + '/products.json?limit=250').then(function (data) {
        return data.products || [];
      }, function (err) {
        lists[handle] = null;
        throw err;
      });
    }
    return lists[handle];
  }

  // Halsbänder der Aktion (Kollektion), ohne die Brezn-Halsbänder.
  function collarSet() {
    return products(d.collars).then(function (items) {
      var set = {};
      items.forEach(function (item) {
        if (item.handle.indexOf('brezn') === -1) set[item.handle] = true;
      });
      return set;
    });
  }

  // Tücher, die der Code gratis macht, mit Bestand.
  function scarfList() {
    return products(d.scarfCollection).then(function (items) {
      var out = [];
      items.forEach(function (item) {
        if (scarves.indexOf(item.handle) === -1 || !item.variants || !item.variants.length) return;
        out.push({ handle: item.handle, title: item.title, id: item.variants[0].id, available: !!item.variants[0].available });
      });
      return out;
    });
  }

  function store(key, value) { try { window.localStorage.setItem(key, value); } catch (err) {} }
  function stored(key) { try { return window.localStorage.getItem(key); } catch (err) { return null; } }
  function tokenOf(cart) { return String((cart && cart.token) || '').split('?')[0]; }
  function isScarf(item) { return scarves.indexOf(item.handle) > -1; }
  function count(items) {
    var total = 0;
    items.forEach(function (item) { total += item.quantity; });
    return total;
  }

  // Für wie viele Halsbänder dieses Warenkorbs schon Tücher dazugelegt wurden.
  function doneCount(token) {
    var parts = String(stored('alMatchAuto') || '').split(':');
    return parts[0] === token ? (Number(parts[1]) || 0) : 0;
  }
  function setDone(token, total) { store('alMatchAuto', token + ':' + total); }

  function cookieCode() {
    var found = '';
    document.cookie.split('; ').forEach(function (part) {
      if (part.indexOf('discount_code=') === 0) found = decodeURIComponent(part.slice(14)).toUpperCase();
    });
    return found;
  }

  function inCart(cart) {
    return (cart.discount_codes || []).some(function (entry) { return String(entry.code).toUpperCase() === CODE; });
  }

  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text) node.textContent = text;
    return node;
  }

  function drop(node) { if (node && node.parentNode) node.parentNode.removeChild(node); }

  function build(kind) {
    var box = el('div', 'al-match al-match--' + kind);
    var label = el('label', 'al-match__label', d.choose);
    var select = el('select', 'al-match__select');
    var button = el('button', 'al-match__btn', d.button);
    var error = el('p', 'al-match__error');
    select.id = 'AlMatchSelect-' + kind;
    label.setAttribute('for', select.id);
    button.type = 'button';
    button.disabled = true;
    error.hidden = true;
    error.setAttribute('role', 'alert');
    box.dataset.kind = kind;
    box.hidden = true;
    // So breit wie Auswahlfelder und Kaufen-Button auf der Produktseite.
    if (kind === 'product') { box.style.maxWidth = '44rem'; box.style.boxSizing = 'border-box'; }
    box.appendChild(el('p', 'al-match__text', d.hint));
    box.appendChild(label);
    box.appendChild(select);
    box.appendChild(button);
    box.appendChild(error);
    button.addEventListener('click', function () { submit(box); });
    return box;
  }

  // Auswahl mit den verfügbaren Tüchern füllen, das gleichnamige ist vorgewählt.
  // Hat das Halsband ein passendes Tuch mit Bestand, ist es fest vorgegeben (ohne Auswahl).
  // Sonst (Tuch ausverkauft, Halsband ohne Paar) freie Wahl unter allen verfügbaren Tüchern.
  function fill(box, list, preferred) {
    var select = box.querySelector('.al-match__select');
    var label = box.querySelector('.al-match__label');
    var text = box.querySelector('.al-match__text');
    var open = list.filter(function (scarf) { return scarf.available; });
    open.sort(function (a, b) { return a.title.localeCompare(b.title); });
    if (!open.length) { box.hidden = true; return; }
    var keep = select.value;
    var chosen = false;
    var fixed = null;
    open.forEach(function (scarf) { if (preferred && scarf.handle === preferred) fixed = scarf; });
    select.innerHTML = '';
    if (fixed && d.hintMatch) {
      var only = el('option', '', fixed.title);
      only.value = String(fixed.id);
      only.selected = true;
      select.appendChild(only);
      text.textContent = d.hintMatch.replace('{title}', fixed.title);
      label.hidden = true;
      select.hidden = true;
      box.hidden = false;
      box.querySelector('.al-match__btn').disabled = false;
      return;
    }
    text.textContent = d.hint;
    label.hidden = false;
    select.hidden = false;
    open.forEach(function (scarf) {
      var option = el('option', '', scarf.title);
      option.value = String(scarf.id);
      if (scarf.handle === preferred) { option.selected = true; chosen = true; }
      select.appendChild(option);
    });
    if (!chosen) {
      var first = el('option', '', d.pick);
      first.value = '';
      first.selected = true;
      select.insertBefore(first, select.firstChild);
    }
    if (keep) {
      Array.prototype.forEach.call(select.options, function (option) {
        if (option.value === keep) select.value = keep;
      });
    }
    box.hidden = false;
    box.querySelector('.al-match__btn').disabled = false;
  }

  function fail(box, message) {
    var error = box.querySelector('.al-match__error');
    error.textContent = message || d.error;
    error.hidden = false;
    box.querySelector('.al-match__btn').disabled = false;
  }

  // Klick auf den Button: Tuch (und auf der Produktseite das Halsband) in den Warenkorb, Code eintragen.
  function submit(box) {
    var select = box.querySelector('.al-match__select');
    var scarfId = Number(select.value);
    var onProduct = box.dataset.kind === 'product';
    var variantId = 0;
    var quantity = 1;
    var total = 0;
    box.querySelector('.al-match__error').hidden = true;
    if (!scarfId) { fail(box, d.pickError); return; }
    if (onProduct) {
      var idInput = document.querySelector('product-info[id^=MainProduct] product-form input[name=id]');
      var qtyInput = document.querySelector('product-info[id^=MainProduct] .product-form__quantity input[name=quantity]');
      variantId = idInput ? Number(idInput.value) : 0;
      quantity = qtyInput ? Math.max(1, Number(qtyInput.value) || 1) : 1;
      if (!variantId) { fail(box, d.size); return; }
    }
    box.querySelector('.al-match__btn').disabled = true;
    Promise.all([call('cart.js'), collarSet()]).then(function (data) {
      var cart = data[0];
      var set = data[1];
      var collarQty = count(cart.items.filter(function (item) { return set[item.handle]; }));
      var scarfQty = count(cart.items.filter(isScarf));
      var hasVariant = !onProduct || cart.items.some(function (item) { return item.variant_id === variantId; });
      var items = [];
      if (!hasVariant) collarQty += quantity;
      var giftQty = Math.min(hasVariant ? 1 : quantity, collarQty - scarfQty);
      if (giftQty > 0) items.push({ id: scarfId, quantity: giftQty, properties: { _al_gift: CODE } });
      if (!hasVariant) items.push({ id: variantId, quantity: quantity });
      total = collarQty;
      return items.length ? call('cart/add.js', { items: items }) : null;
    }).then(function () {
      return call('cart/update.js', { discount: CODE });
    }).then(function (cart) {
      setDone(tokenOf(cart), total);
      window.location.href = d.cart;
    }).catch(function (err) {
      fail(box, err && err.message);
    });
  }

  // Nach einer Änderung: Warenkorb-Seite neu laden, sonst Zähler und Fenster nachziehen.
  function refresh(names) {
    if (d.page === 'cart') { window.location.reload(); return; }
    nativeFetch(root + '?sections=cart-icon-bubble,cart-notification-button').then(function (response) {
      return response.json();
    }).then(function (data) {
      ['cart-icon-bubble', 'cart-notification-button'].forEach(function (id) {
        var holder = document.getElementById(id);
        var html = data && data[id];
        if (!holder || !html) return;
        var inner = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
        if (inner) holder.innerHTML = inner.innerHTML;
      });
    }).catch(function () {});
    if (!names) return;
    var target = document.getElementById('cart-notification-product');
    if (!target) return;
    drop(target.querySelector('.al-match-note'));
    target.appendChild(el('p', 'al-match-note', d.added.replace('{title}', names)));
  }

  // Warenkorb-Seite: „Geschenk“ am Tuch und Hinweis mit Button, solange ein Tuch fehlt.
  function show(state) {
    if (d.page !== 'cart') return;
    var box = document.getElementById('AlMatchCart');
    function tag() {
      Array.prototype.forEach.call(document.querySelectorAll('.al-gift'), drop);
      if (!state) return;
      state.cart.items.forEach(function (item, index) {
        if (!isScarf(item) || item.final_line_price !== 0) return;
        var row = document.getElementById('CartItem-' + (index + 1));
        var title = row ? (row.querySelector('.cart-item__title') || row.querySelector('.cart-item__name')) : null;
        if (title) title.insertAdjacentElement('afterend', el('span', 'al-gift', d.gift));
      });
    }
    tag();
    window.setTimeout(tag, 700);
    var host = document.querySelector('#main-cart-footer .cart__blocks');
    if (!state || !host || state.missing <= 0) { drop(box); return; }
    if (!box) {
      box = build('cart');
      box.id = 'AlMatchCart';
      host.insertBefore(box, host.firstChild);
    }
    fill(box, state.list, state.preferred);
  }

  function work() {
    return call('cart.js').then(function (cart) {
      if (!cart.item_count) { show(null); return null; }
      return Promise.all([collarSet(), scarfList()]).then(function (data) {
        var set = data[0];
        var list = data[1];
        var byHandle = {};
        list.forEach(function (scarf) { byHandle[scarf.handle] = scarf; });
        var collarItems = cart.items.filter(function (item) { return set[item.handle]; });
        var scarfItems = cart.items.filter(isScarf);
        var gifts = scarfItems.filter(function (item) { return item.properties && item.properties._al_gift; });
        var collarQty = count(collarItems);
        var scarfQty = count(scarfItems);
        var codeOn = inCart(cart) || cookieCode() === CODE;
        var token = tokenOf(cart);
        var have = {};
        var want = {};
        var order = [];
        var preferred = '';
        scarfItems.forEach(function (item) { have[item.handle] = (have[item.handle] || 0) + item.quantity; });
        collarItems.forEach(function (item) {
          var handle = pairs[item.handle];
          if (!handle) return;
          if (!want[handle]) { want[handle] = 0; order.push(handle); }
          want[handle] += item.quantity;
        });
        order.forEach(function (handle) {
          if (!preferred && (have[handle] || 0) < want[handle]) preferred = handle;
        });

        // Mehr dazugelegte Tücher als Halsbänder (Halsband entfernt): überzählige wieder herausnehmen,
        // zuerst die, deren Halsband fehlt.
        if (gifts.length && scarfQty > collarQty) {
          var excess = scarfQty - collarQty;
          var updates = {};
          var changed = false;
          [true, false].forEach(function (orphansOnly) {
            gifts.forEach(function (item) {
              if (excess <= 0) return;
              var left = updates[item.key] === undefined ? item.quantity : updates[item.key];
              var spare = orphansOnly ? Math.max(0, left - (want[item.handle] || 0)) : left;
              var take = Math.min(spare, excess);
              if (take > 0) { updates[item.key] = left - take; excess -= take; changed = true; }
            });
          });
          if (changed) {
            setDone(token, collarQty);
            return call('cart/update.js', { updates: updates }).then(function () { refresh(''); });
          }
        }

        if (!collarItems.length) { show(null); return null; }

        // Code aktiv und neue Halsbänder ohne Tuch: die gleichnamigen Tücher dazulegen.
        if (codeOn && collarQty > scarfQty && collarQty > doneCount(token)) {
          var missing = collarQty - scarfQty;
          var items = [];
          var names = [];
          order.forEach(function (handle) {
            var scarf = byHandle[handle];
            if (!scarf || !scarf.available) return;
            var amount = Math.min(want[handle] - (have[handle] || 0), missing);
            if (amount <= 0) return;
            items.push({ id: scarf.id, quantity: amount, properties: { _al_gift: CODE } });
            names.push(scarf.title);
            missing -= amount;
          });
          setDone(token, collarQty);
          if (items.length) {
            return call('cart/add.js', { items: items }).then(function () {
              return call('cart/update.js', { discount: CODE });
            }).then(function (updated) {
              setDone(tokenOf(updated), collarQty);
              refresh(names.join(', '));
            });
          }
        }

        // Code kam über den Link, steht aber noch nicht im Warenkorb: eintragen, damit das Tuch 0 € zeigt.
        if (codeOn && scarfItems.length && !inCart(cart) && stored('alMatchCode') !== token) {
          store('alMatchCode', token);
          return call('cart/update.js', { discount: CODE }).then(function () { refresh(''); });
        }

        show({ cart: cart, list: list, missing: collarQty - scarfQty, preferred: preferred });
        return null;
      });
    });
  }

  function sync() {
    if (running) { again = true; return; }
    running = true;
    work().catch(function () {}).then(function () {
      running = false;
      if (again) { again = false; sync(); }
    });
  }

  // Jede Änderung am Warenkorb durch das Theme löst eine Prüfung aus.
  window.fetch = function (input, init) {
    var promise = nativeFetch(input, init);
    var url = typeof input === 'string' ? input : ((input && input.url) || '');
    if (url.indexOf('/cart/add') > -1 || url.indexOf('/cart/change') > -1 || url.indexOf('/cart/update') > -1 || url.indexOf('/cart/clear') > -1) {
      promise.then(function () { window.setTimeout(sync, 60); }, function () {});
    }
    return promise;
  };

  function start() {
    if (d.collar && d.collar.indexOf('brezn') === -1) {
      var form = document.querySelector('product-info[id^=MainProduct] product-form');
      if (form) {
        var box = build('product');
        box.id = 'AlMatchProduct';
        form.insertAdjacentElement('beforebegin', box);
        scarfList().then(function (list) { fill(box, list, pairs[d.collar]); }).catch(function () {});
      }
    }
    if (d.line === 'true') {
      var grid = document.getElementById('ProductGridContainer');
      if (grid && !document.querySelector('.al-match-line')) {
        grid.parentNode.insertBefore(el('p', 'al-match-line page-width', d.lineText), grid);
      }
    }
    if (Number(d.count) > 0 || d.page === 'cart') sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
